import { NewsletterItem } from '..';
import { MatDialogRef } from '@angular/material/dialog';
import { ConfirmationDialogAfterClosedModel } from '../../../../../ui-kit';

export class NewsletterItemLoad {
  public static readonly type = '[NewsletterItem] Load';

  constructor(public payload: number) {}
}

export class NewsletterItemSave {
  public static readonly type = '[NewsletterItem] Save';

  constructor(public payload: Partial<NewsletterItem>) {}
}

export class NewsletterTypesLoad {
  public static readonly type = '[NewsletterItem] Load Types';
}

export class NewsletterItemSend {
  public static readonly type = '[NewsletterItem] Send';

  constructor(public payload: { newsletterItemId: number; dialog: MatDialogRef<ConfirmationDialogAfterClosedModel> }) {}
}

export class NewsletterItemInitialState {
  public static readonly type = '[NewsletterItem] Set initial state';
}
